import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";
import { AuthContext } from "../../../Context/AuthContext";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s", cursor: "pointer",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "flex", alignItems: "center", gap: 5 };

const ManageAuditRenewal = () => {
  const { selectedJfmcType } = useContext(AuthContext);
  const [vfcId, setVfcId] = useState("");
  const [vfcs, setVfcs] = useState([]);
  const [dataType, setDataType] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    if (selectedJfmcType) { setVfcId(""); fetchVfc(selectedJfmcType._id); }
  }, [selectedJfmcType]);

  const fetchVfc = async (jfmcTypeId) => {
    setLoading(true);
    try {
      const config = Authorization();
      const res = await axios.post(`${Api}/api/vfcs/names`, { jfmcTypeId }, config);
      setVfcs(res.data.vfcs);
    } catch (err) { console.error("Error fetching VFC data", err); }
    finally { setLoading(false); }
  };

  const handleFetchData = () => {
    if (vfcId && dataType) {
      const config = Authorization();
      const endpoint = dataType === "Audit" ? "audits" : "renewal";
      axios.post(`${Api}/api/${endpoint}/previous`, { vfcId }, config)
        .then((res) => { setData(res.data); setError(null); })
        .catch((err) => { console.error(err); setError(`No data found for ${dataType}.`); setData([]); });
    }
  };

  useEffect(() => { handleFetchData(); }, [vfcId, dataType]);

  /* ════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════ */
  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Manage Audit / Renewal</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>JFMC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Manage Audit / Renewal</span>
        </div>
      </div>

      {/* ── No JFMC type selected ── */}
      {!selectedJfmcType ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>JFMC Type not selected</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar</div>
        </div>
      ) : (
        <>
          {/* ── Filter Card ── */}
          <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "20px 24px", marginBottom: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <span style={{ width: 30, height: 30, background: "linear-gradient(135deg,#1B5E20,#43A047)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14 }}>
                <i className="mdi mdi-filter-variant" />
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#1A202C" }}>Filter Records</span>
              <span style={{ fontSize: 11, color: "#A0AEC0", marginLeft: 4 }}>Select JFMC and data type to load records</span>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0,1fr))", gap: 16 }}>
              <div>
                <label style={labelStyle}><i className="mdi mdi-home-group" style={{ color: "#43A047" }} /> JFMC Name</label>
                <select value={vfcId} onChange={(e) => setVfcId(e.target.value)}
                  style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}>
                  <option value="">— Select JFMC —</option>
                  {vfcs.map((v) => <option key={v._id} value={v._id}>{v.vfcName}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}><i className="mdi mdi-format-list-bulleted" style={{ color: "#43A047" }} /> Data Type</label>
                <select value={dataType} onChange={(e) => setDataType(e.target.value)}
                  style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}>
                  <option value="">— Select Data Type —</option>
                  <option value="Audit">Audit</option>
                  <option value="Renewal">Renewal</option>
                </select>
              </div>
            </div>

            {error && (
              <div style={{ marginTop: 12, padding: "8px 14px", background: "#FFEBEE", border: "1px solid #FFCDD2", borderRadius: 8, fontSize: 13, color: "#C62828", display: "flex", alignItems: "center", gap: 8 }}>
                <i className="mdi mdi-alert-circle-outline" /> {error}
              </div>
            )}
          </div>

          {/* ── Data Table Card ── */}
          {dataType ? (
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
                <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
                  <i className={`mdi ${dataType === "Audit" ? "mdi-clipboard-text-outline" : "mdi-autorenew"}`} />
                </span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>{dataType} Records</span>
                <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 50 }}>{data.length} records</span>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                  <thead>
                    <tr>
                      {["#", "JFMC Name", "Date",
                        ...(dataType === "Audit" ? ["Balance During Audit", "Auditor Name"] : ["Renewal No"]),
                        "Document"
                      ].map((h) => (
                        <th key={h} style={{ padding: "11px 16px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "#4A5568", borderBottom: "1px solid #EDF2F7", background: "#F7FAFC", whiteSpace: "nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.length === 0 ? (
                      <tr><td colSpan={6} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: 13 }}>No records found</td></tr>
                    ) : (
                      data.map((item, index) => (
                        <tr key={index} style={{ borderBottom: "1px solid #EDF2F7" }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#F7FAFC"}
                          onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                          <td style={{ padding: "10px 16px", color: "#718096" }}>{index + 1}</td>
                          <td style={{ padding: "10px 16px", color: "#1A202C", fontWeight: 600 }}>{item.vfcId?.vfcName}</td>
                          <td style={{ padding: "10px 16px", color: "#4A5568", whiteSpace: "nowrap" }}>
                            {new Date(dataType === "Audit" ? item.auditDate : item.renewalDate).toLocaleDateString("en-IN")}
                          </td>
                          {dataType === "Audit" ? (
                            <>
                              <td style={{ padding: "10px 16px" }}>
                                <span style={{ background: "#E8F5E9", color: "#2E7D32", fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 50 }}>₹{item.balanceDuringAudit}</span>
                              </td>
                              <td style={{ padding: "10px 16px", color: "#4A5568" }}>{item.auditorName}</td>
                            </>
                          ) : (
                            <td style={{ padding: "10px 16px" }}>
                              <span style={{ background: "#E8F5E9", color: "#2E7D32", fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 50 }}>{item.renewalNo}</span>
                            </td>
                          )}
                          <td style={{ padding: "10px 16px" }}>
                            {item.uploadDocument ? (
                              <a href={item.uploadDocument} target="_blank" rel="noopener noreferrer"
                                style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "4px 10px", background: "#E8F5E9", color: "#2E7D32", borderRadius: 6, fontSize: 12, fontWeight: 600, textDecoration: "none" }}>
                                <i className="mdi mdi-file-outline" /> View
                              </a>
                            ) : <span style={{ color: "#A0AEC0", fontSize: 12 }}>—</span>}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", padding: "48px 24px", textAlign: "center" }}>
              <div style={{ width: 60, height: 60, background: "#E8F5E9", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
                <i className="mdi mdi-filter-outline" style={{ fontSize: 28, color: "#2E7D32" }} />
              </div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>Select filters above</div>
              <div style={{ fontSize: 12, color: "#A0AEC0" }}>Choose a JFMC and data type to view records</div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ManageAuditRenewal;
